import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Logo } from '@/components/ui/Logo'

export function Terms() {
  return (
    <div className="min-h-screen bg-black">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.01)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.01)_1px,transparent_1px)] bg-[size:64px_64px]" />
      </div>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/[0.06]">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="transition-transform hover:scale-105">
            <Logo className="text-white" />
          </Link>
          <Link
            to="/"
            className="group inline-flex items-center gap-2 text-sm text-gray-500 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
            <span>Voltar</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="relative container mx-auto px-4 py-16 max-w-3xl">
        <div className="mb-12">
          <span className="inline-block text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-4">
            Termos de Uso
          </h1>
          <p className="text-sm text-gray-600">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </p>
        </div>

        <div className="space-y-10 text-gray-400">
          <Section title="1. Aceitação dos Termos">
            <p>
              Ao acessar e utilizar o zonisigma.app, você concorda em cumprir estes Termos de Uso.
              Se você não concordar com qualquer parte destes termos, não deve utilizar nosso serviço.
            </p>
          </Section>

          <Section title="2. Descrição do Serviço">
            <p>
              O zonisigma.app é uma ferramenta independente de gestão de banca que permite aos usuários
              acompanhar e analisar seus resultados de trading através de integração com a plataforma Futura Broker.
            </p>
            <p>
              Este serviço é fornecido "como está" e não possui qualquer vínculo, afiliação ou endosso
              oficial da marca Futura Broker.
            </p>
          </Section>

          <Section title="3. Uso do Serviço">
            <p>Você concorda em:</p>
            <ul className="list-none space-y-2 mt-3">
              {[
                'Fornecer informações verdadeiras e precisas',
                'Manter a confidencialidade de seu código de integração',
                'Não utilizar o serviço para fins ilegais ou não autorizados',
                'Não tentar acessar áreas restritas do sistema',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-1 h-1 rounded-full bg-gray-600 mt-2" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Section>

          <Section title="4. Limitação de Responsabilidade">
            <p>
              O zonisigma.app não se responsabiliza por decisões de trading tomadas com base nas
              informações exibidas na plataforma. Os dados apresentados são apenas para fins informativos
              e de acompanhamento.
            </p>
            <p>
              Não garantimos a disponibilidade ininterrupta do serviço ou a precisão absoluta dos dados
              sincronizados.
            </p>
          </Section>

          <Section title="5. Propriedade Intelectual">
            <p>
              Todo o conteúdo, design e código do zonisigma.app são protegidos por direitos autorais.
              É proibida a reprodução, distribuição ou modificação sem autorização prévia.
            </p>
          </Section>

          <Section title="6. Modificações">
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações
              significativas serão comunicadas através da plataforma.
            </p>
          </Section>

          <Section title="7. Contato">
            <p>
              Para dúvidas sobre estes termos, entre em contato através do email disponível na plataforma.
            </p>
          </Section>
        </div>
      </main>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-4">
      <h2 className="text-lg font-semibold text-white">{title}</h2>
      <div className="space-y-3 text-sm leading-relaxed">{children}</div>
    </section>
  )
}
